import { Component, OnInit } from '@angular/core';
import { UtilityServiceService } from '../services/utility-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-carrier-congratulations',
  templateUrl: './carrier-congratulations.component.html',
  styleUrls: ['./carrier-congratulations.component.css']
})
export class CarrierCongratulationsComponent implements OnInit {
  isAdmin = false;

  constructor(public utility: UtilityServiceService, private route: ActivatedRoute) { }
 sageCustomerCode = ''
  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.sageCustomerCode = params.get("id");
    })
    if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
      this.isAdmin = true;
     
    }
  }
landing(){
  this.utility.landingPage();
}
}
